import React from 'react';
import { FormTextEditor } from '@Components/Form';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';
import { Box, InputLabel } from '@mui/material';
import UploadImageFormFields from '@Containers/UploadImageFormFields';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useWatch } from 'react-hook-form';
import {
  disabledFormInputStyles,
  disabledTextAreaInputStyles,
} from '@Components/Form/styles';

type FormBusinessGroupInformationProps = {
  index: number;
};

const FormBusinessGroupInformation: React.FC<
  FormBusinessGroupInformationProps
> = ({ index }) => {
  const { isCompletedTh, isCompletedEn } =
    useWatch({
      name: 'productInformation.completedSection',
    }) ?? ({} as CompleteSectionFormValues);
  return (
    <Box flexDirection={'column'}>
      <Box>
        <InputLabel required>
          กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจ
        </InputLabel>
      </Box>

      <Box maxWidth={'100%'} mt={2}>
        <FormTextAreaAutoSize
          name={`productInformation.businessGroupInfos.${index}.nameTh`}
          label="ภาษาไทย"
          inputProps={{
            minRows: 3,
            placeholder: 'กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจ (ไทย)',
          }}
          sx={isCompletedTh ? disabledTextAreaInputStyles : {}}
        />

        <FormTextAreaAutoSize
          name={`productInformation.businessGroupInfos.${index}.nameEn`}
          label="ภาษาอังกฤษ"
          inputProps={{
            minRows: 3,
            placeholder: 'กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจ (อังกฤษ)',
          }}
          sx={isCompletedEn ? disabledTextAreaInputStyles : {}}
        />
      </Box>

      <Box flexDirection={'column'} mt={2}>
        <Box mt={1}>
          <InputLabel required>
            กรุณาอธิบายผลิตภัณฑ์, บริการ หรือ กลุ่มธุรกิจ (ไทย)
          </InputLabel>

          <FormTextEditor
            name={`productInformation.businessGroupInfos.${index}.descriptionTh`}
            inputProps={{ placeholder: 'กรุณาระบุ (ไทย)' }}
            mt={1}
            sx={isCompletedTh ? disabledFormInputStyles : {}}
          />
        </Box>

        <Box mt={1}>
          <InputLabel required>
            กรุณาอธิบายผลิตภัณฑ์, บริการ หรือ กลุ่มธุรกิจ (อังกฤษ)
          </InputLabel>
          <FormTextEditor
            name={`productInformation.businessGroupInfos.${index}.descriptionEn`}
            inputProps={{ placeholder: 'กรุณาระบุ (อังกฤษ)' }}
            mt={1}
            sx={isCompletedEn ? disabledFormInputStyles : {}}
          />
        </Box>
      </Box>
      <Box mt={2}>
        <UploadImageFormFields
          title={'รูปภาพผลิตภัณฑ์, บริการ หรือ กลุ่มธุรกิจ '}
          name={`productInformation.businessGroupInfos.${index}`}
          disabledTh={isCompletedTh}
          disabledEn={isCompletedEn}
        />
      </Box>
    </Box>
  );
};

export default FormBusinessGroupInformation;
